// Zentrale Feld-Optionen für die Erfassung
// Kompatibel mit den Werten im Baumwächter-Hauptsystem

export const BAUMARTEN = [
  'Linde/Tilia sp.',
  'Eiche/Quercus sp.',
  'Berg-Ahorn/Acer pseudoplatanus',
  'Spitz-Ahorn/Acer platanoides',
  'Esche/Fraxinus excelsior',
  'Buche/Fagus sylvatica',
  'Hainbuche/Carpinus betulus',
  'Birke/Betula sp.',
  'Erle/Alnus sp.',
  'Pappel/Populus sp.',
  'Weide/Salix sp.',
  'Kastanie/Aesculus hippocastanum',
  'Robinie/Robinia pseudoacacia',
  'Walnuss/Juglans regia',
  'Eibe/Taxus baccata',
  'Fichte/Picea abies',
  'Kiefer/Pinus sp.',
  'Tanne/Abies sp.',
  'Apfel/Malus sp.',
  'Kirsche/Prunus sp.',
  'Weißdorn/Crataegus sp.',
  'Holunder/Sambucus nigra',
  'Ulme/Ulmus sp.',
];

export const FUNKTIONEN = [
  'Allee',
  'Straßenbegleitgrün',
  'Park',
  'Friedhof',
  'Spielplatz',
  'Wohngebiet',
  'Einzelbaum',
  'Hofbaum',
  'Grünfläche öffentlich',
];

export const VITALITAETEN = [
  'gesund',
  'leicht eingeschränkt',
  'absterbend',
  'tot',
];

export const ZUSTAENDE = [
  'gut',
  'befriedigend',
  'schlecht',
  'sehr schlecht',
];

export const ENTWICKLUNGEN = [
  'Jungbaum',
  'Heranwachsend',
  'Ausgewachsen',
  'Alterungsphase',
];

export const KONTROLL_INTERVALLE = [
  'halbjährlich',
  'jährlich',
  '2-jährlich',
  '3-jährlich',
];

// FLL-Schäden – mit Bereich → Beschreibungs-Liste
export const SCHADEN_BEREICHE = ['Krone', 'Stamm', 'Stammfuß', 'Wurzel'];

export const SCHADEN_BESCHREIBUNGEN: Record<string, string[]> = {
  'Krone': [
    'Totholz',
    'Astabbruch',
    'Astungswunde',
    'sich kreuzende und reibende Äste',
    'Stammaustriebe',
    'alte Kappungsstellen',
    'Lose aufliegende Kronenteile',
    'Wipfeldürre',
    'Kopfbaum-Pflege erforderlich',
    'Höhlung',
    'Hexenbesen',
    'Schiefstand der Krone',
  ],
  'Stamm': [
    'Rindenverlust',
    'Rindenschaden',
    'Schrägstand',
    'Stockaustriebe',
    'Rippe (Wuchsfehler)',
    'Risse',
    'Pilzfruchtkörper',
    'Kappung',
    'Baumfremder Bewuchs (Efeu)',
    'Baumfremder Bewuchs (Mistel)',
    'Stammhöhle',
    'Frostrisse',
    'Druckzwiesel',
  ],
  'Stammfuß': [
    'Höhlung am Stammfuß',
    'Pilzfruchtkörper am Stammfuß',
    'Rindennekrose',
    'Wurzelhalsfäule',
    'Verletzungen am Stammfuß',
  ],
  'Wurzel': [
    'Freiliegende Wurzeln',
    'Wurzelschaden',
    'Wurzelschäden',
    'Anfahrtsschaden',
    'Bodenverdichtung',
    'Aufschüttung im Wurzelraum',
    'Wurzelfäule',
  ],
};

export const PRIORITAETEN = ['niedrig', 'mittel', 'hoch', 'dringend'];
export const SCHWEREGRADE = ['Gering', 'Mittel', 'Hoch', 'Sehr hoch'];
